/**
 * Logs action type, payload, and result state to the browser console.
 * @param {*} reducer a reducing function to wrap with logging
 * @returns {Function} a wrapped reducer function
 */
const withLogger = (reducer) => (state, action) => {
  const result = reducer(state, action)

  return result
}

export default withLogger
